import { Slot } from '@radix-ui/react-slot'

import { cn } from '~/utils/cn'
import { type VariantProps, tv } from '~/utils/tv'

type BigNumberProps = React.ComponentPropsWithRef<'h1'> &
  VariantProps<typeof bigNumberVariants> & {
    asChild?: boolean
  }

const bigNumberVariants = tv({
  base: 'font-bold font-sans leading-tiny tracking-normal no-underline',
  variants: {
    variant: {
      'large-bold': 'text-twelvepulse',
      'default-bold': 'text-tenpulse',
      'small-bold': 'text-eightpulse',
    },
  },
  defaultVariants: {
    variant: 'large-bold',
  },
})

function BigNumber({ variant, asChild, ...props }: BigNumberProps) {
  const Comp = asChild ? Slot : 'h1'
  return (
    <Comp
      {...props}
      className={cn(
        bigNumberVariants({
          variant,
        })
      )}
    />
  )
}

export { BigNumber, type BigNumberProps }
